module.exports = __webpack_public_path__ + "img/ricelog_pinicon_033.d9b23be4.png";